const { curry } = require('../functions');

/**
 * Turns an object or a deeply nested array into a flat array
 * by applying a callback function
 *
 * @export
 * @param {object|array} item - original object
 * @param {function(item: any, key: any)} fn - function to be applied
 *        to each object key (must return an array)
 * @returns {array} the flat mapped result
 */
exports.flatMap = curry((item, fn) => {
  if (item) {
    return Object.keys(item).reduce(
      (res, key) => [...res, ...fn(item[key], key)],
      []
    );
  } else {
    return [];
  }
});

/**
 * fork and join
 * Higher order function
 * executes two branches and reunites them afterwards
 *
 * @export
 * @param {function(or: any)} alternative - first to get executed
 * @param {function(a: any)} rightFn - second to get executed
 * @param {function(res1: any, res2: any)} joinFn - function that calculates the result
 * @returns {function(a)} - func that takes an argument that is passed to left and right
 */
exports.pathOr = curry((or, path, obj) => {
  let res = obj;
  if (typeof obj !== 'object') {
    return or;
  }
  for (let key of path) {
    if (res[key] !== undefined) {
      res = res[key];
    } else {
      return or;
    }
  }
  return res;
});

exports.mergeDeep = (left, right) => {
  if (
    typeof left !== 'object' ||
    Array.isArray(left) ||
    typeof right !== 'object' ||
    Array.isArray(right) ||
    right === null
  ) {
    return right;
  }
  const o = Object.assign({}, left);
  Object.keys(right).forEach(key => {
    if (o[key] !== undefined) {
      o[key] = exports.mergeDeep(o[key], right[key]);
    } else {
      o[key] = right[key];
    }
  });

  return o;
};

exports.path = exports.pathOr(null);
